import { Alert } from '@festina-life/ui/feedback'
import { useTranslate } from '@festina-life/ui/hooks'
import { paperStyles } from '@festina-life/ui/libs'
import cx from 'classnames'
import { useEffect, useState } from 'react'

import { useNavigationParams } from '../../system/useNavigationParams'
import { useAllConciseBranches } from '../../uiModels/branches/useAllConciseBranches'
import { useOperationsContext } from '../../workspace/operationsContext'
import { ChangesetStateWarning } from '../changesetStateWarning/ChangesetStateWarning'
import { ConfigurationBreadcrumb } from '../configurationBreadcrumb/ConfigurationBreadcrumb'
import { LocationErrorsCount } from './LocationErrorsCount'

export const WorkspaceAndBranchStatusFooter = () => {
  const [isShowingInexistentBranchError, setIsShowingInexistentBranchError] =
    useState(true)
  const conciseBranches = useAllConciseBranches()
  const { workspaceKey } = useOperationsContext()
  const { server } = useNavigationParams()
  const translate = useTranslate()
  const isWorkspaceBranchDeleted =
    workspaceKey &&
    !conciseBranches[server]?.find(
      (branch) => branch.name === workspaceKey.branchKey.name,
    )

  useEffect(() => {
    if (!workspaceKey) {
      setIsShowingInexistentBranchError(true)
    }
  }, [workspaceKey])

  return (
    <div className="w-full">
      <div className="flex flex-col gap-y-2">
        <ChangesetStateWarning />
      </div>
      {isWorkspaceBranchDeleted && isShowingInexistentBranchError && (
        <Alert
          severity="error"
          className="p-1! max-w-full!"
          onClose={() => setIsShowingInexistentBranchError(false)}
        >
          {translate('workspace.error.branchNotFound', {
            branchName: workspaceKey?.branchKey.name ?? '',
          })}
        </Alert>
      )}
      <div
        className={cx(
          'flex w-full flex-row items-center justify-between',
          paperStyles({ isFaded: false, borders: ['top'] }),
        )}
      >
        <ConfigurationBreadcrumb />
        <LocationErrorsCount />
      </div>
    </div>
  )
}
